// DarkModeToggle.js
import React from 'react';
// import { useTheme } from './ThemeContext.js';
import { Switch,Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../ThemeContext.js';

const ToggleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const DarkModeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
     <Tooltip title="Theme" arrow>
    <ToggleContainer>
      <FiSun color={isDarkMode ? '#808080' : '#FFA500'} />
      <Switch
        checked={isDarkMode}
        onChange={toggleTheme}
        color="default"
        inputProps={{ 'aria-label': 'dark mode toggle' }}
      />
      <FiMoon color={isDarkMode ? '#FFD700' : '#808080'} />
    </ToggleContainer>

    </Tooltip>
  );
};

export default DarkModeToggle;
